
import { defineComponent, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import MainMenu from '@/components/MainMenu.vue';
import * as Stripe from '@/utils/StripeService';

export default defineComponent({
  name: 'App',
  components: {
    MainMenu,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const user = computed(() => store.getters.currentUser);
    const userData = computed(() => store.getters.getUserData);
    const locations = computed(() => store.getters.getLocations);

    const showAuthenticatedHeader = computed(() => {
      const hiddenRoutes = ['Login', 'Register', 'ForgotPassword'];
      return !hiddenRoutes.includes(route.name as string);
    });

    Stripe.retrieveProducts()
      .then((results) => {
        const products = [] as any[];
        const snapshots = store.state.unsubscribe;
        results.forEach((product) => {
          products.push(product);
          snapshots.push(product);
        });
        store.dispatch('updateProducts', products);
        store.commit('setUnsubscribe', snapshots);
      })
      .catch((error) => {
        const { message } = error;
        console.error(message);
      });

    return {
      user,
      userData,
      locations,
      showAuthenticatedHeader,
    };
  },
});
